var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcanaNoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_d_1944_28539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 145,
    height: 145,
    rx: 5,
    fill: "url(#paint0_linear_1944_28539)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 144,
    height: 144,
    rx: 4.5,
    stroke: "url(#paint1_linear_1944_28539)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_28539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9601 93H58.0399C55.2564 93 53 90.7393 53 87.9504V64.0496C53 61.2607 55.2564 59 58.0399 59H93.9601C96.7436 59 99 61.2607 99 64.0496V87.9504C99 90.7393 96.7436 93 93.9601 93ZM80.7569 73.7379L73.6524 81.9217C73.1892 82.4553 72.3668 82.4698 71.885 81.9526L68.064 77.8508C67.5937 77.3459 66.7949 77.3459 66.3246 77.8508L59.7664 84.8909C59.0565 85.6528 59.5959 86.8961 60.6361 86.8961H91.3637C92.3842 86.8961 92.931 85.6933 92.2613 84.9219L82.5523 73.7377C82.0781 73.1913 81.2314 73.1913 80.7572 73.7377L80.7569 73.7379ZM71.1268 66.5118C69.2481 66.5118 67.7254 68.0377 67.7254 69.9199C67.7254 71.802 69.2483 73.3279 71.1268 73.3279C73.0053 73.3279 74.5283 71.802 74.5283 69.9199C74.5283 68.0377 73.0053 66.5118 71.1268 66.5118Z",
    fill: "url(#paint2_linear_1944_28539)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1944_28539",
    x: 0,
    y: 0,
    width: 155,
    height: 155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1944_28539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1944_28539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1944_28539",
    x1: 149,
    y1: 3,
    x2: 99.8621,
    y2: 198.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1944_28539",
    x1: 4,
    y1: 94.2001,
    x2: 149,
    y2: 94.2001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1944_28539",
    x1: 53,
    y1: 77.1333,
    x2: 99,
    y2: 77.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1944_28539",
    x1: 15,
    y1: 110.067,
    x2: 138,
    y2: 110.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_28539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 34,
    fill: "white",
    transform: "translate(53 59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcanaNoImg);
export default __webpack_public_path__ + "static/media/arcana-no-img.81bb67a2001d3518735e5b95fe947c24.svg";
export { ForwardRef as ReactComponent };